import { AttributeFilterFiltersInput } from '@generated'

export function removeAttributeDuplicates(filters: AttributeFilterFiltersInput[]) {
  const seenAttributeIDs = new Set<number>()
  return filters.filter((filter) => {
    if (seenAttributeIDs.has(filter.attributeID)) {
      return false
    }
    seenAttributeIDs.add(filter.attributeID)
    return true
  })
}
